import { css } from "styled-components"

import { colors } from "@izettle/otto"

export const ButtonColorsCss = {
  primary: css`
    border-color: ${colors.action.primary.border.default};
    background: ${colors.action.primary.background.default};
    color: ${colors.action.primary.text.default};

    &:hover {
      border-color: ${colors.action.primary.border.hover};
      background: ${colors.action.primary.background.hover};
      color: ${colors.action.primary.text.hover};
    }

    &:active {
      border-color: ${colors.action.primary.border.selected};
      background: ${colors.action.primary.background.selected};
      color: ${colors.action.primary.text.selected};
    }

    &:disabled {
      border-color: ${colors.action.primary.border.disabled};
      background: ${colors.action.primary.background.disabled};
      color: ${colors.action.primary.text.disabled};
    }
  `,

  secondary: css`
    /* stylelint-disable-next-line @izettle/border-color */
    border-color: ${colors.action.secondary.border.default};
    background: ${colors.action.secondary.background.default};
    color: ${colors.action.secondary.text.default};

    &:hover {
      border-color: ${colors.action.secondary.border.hover};
      background: ${colors.action.secondary.background.hover};
      color: ${colors.action.secondary.text.hover};
    }

    &:active {
      border-color: ${colors.action.secondary.border.selected};
      background: ${colors.action.secondary.background.selected};
      color: ${colors.action.secondary.text.selected};
    }

    &:disabled {
      border-color: ${colors.action.secondary.border.disabled};
      background: ${colors.action.secondary.background.disabled};
      color: ${colors.action.secondary.text.disabled};
    }
  `,

  minor: css`
    /* stylelint-disable-next-line @izettle/border-color */
    border-color: ${colors.border.form};
    background: ${colors.action.minor.background.default};
    color: ${colors.action.minor.text.default};

    &:hover {
      border-color: ${colors.border.form};
      background: ${colors.action.minor.background.hover};
      color: ${colors.action.minor.text.hover};
    }

    &:active {
      border-color: ${colors.border.form};
      background: ${colors.action.minor.background.selected};
      color: ${colors.action.minor.text.selected};
    }

    &:disabled {
      border-color: ${colors.action.minor.border.disabled};
      background: ${colors.action.minor.background.disabled};
      color: ${colors.action.minor.text.disabled};
    }
  `,

  destructive: css`
    border-color: ${colors.action.destructive.border.default};
    background: ${colors.action.destructive.background.default};
    color: ${colors.action.destructive.text.default};

    &:hover {
      border-color: ${colors.action.destructive.border.hover};
      background: ${colors.action.destructive.background.hover};
      color: ${colors.action.destructive.text.hover};
    }

    &:active {
      border-color: ${colors.action.destructive.border.selected};
      background: ${colors.action.destructive.background.selected};
      color: ${colors.action.destructive.text.selected};
    }

    &:disabled {
      border-color: ${colors.action.destructive.border.disabled};
      background: ${colors.action.destructive.background.disabled};
      color: ${colors.action.destructive.text.disabled};
    }
  `,
  destructiveSolid: css`
    border-color: ${colors.action.destructiveSolid.border.default};
    background: ${colors.action.destructiveSolid.background.default};
    color: ${colors.action.destructiveSolid.text.default};

    &:hover {
      border-color: ${colors.action.destructiveSolid.border.hover};
      background: ${colors.action.destructiveSolid.background.hover};
      color: ${colors.action.destructiveSolid.text.hover};
    }

    &:active {
      border-color: ${colors.action.destructiveSolid.border.selected};
      background: ${colors.action.destructiveSolid.background.selected};
      color: ${colors.action.destructiveSolid.text.selected};
    }

    &:disabled {
      border-color: ${colors.action.destructiveSolid.border.disabled};
      background: ${colors.action.destructiveSolid.background.disabled};
      color: ${colors.action.destructiveSolid.text.disabled};
    }
  `,

  inlineDestructive: css`
    border-color: ${colors.action.inlineDestructive.border.default};
    background: ${colors.action.inlineDestructive.background.default};
    color: ${colors.action.inlineDestructive.text.default};

    &:hover {
      border-color: ${colors.action.inlineDestructive.border.hover};
      background: ${colors.action.inlineDestructive.background.hover};
      color: ${colors.action.inlineDestructive.text.hover};
    }

    &:active {
      border-color: ${colors.action.inlineDestructive.border.selected};
      background: ${colors.action.inlineDestructive.background.selected};
      color: ${colors.action.inlineDestructive.text.selected};
    }

    &:disabled {
      border-color: ${colors.action.inlineDestructive.border.disabled};
      background: ${colors.action.inlineDestructive.background.disabled};
      color: ${colors.action.inlineDestructive.text.disabled};
    }
  `,
  inline: css`
    border-color: ${colors.action.inline.border.default};
    background: ${colors.action.inline.background.default};
    color: ${colors.action.inline.text.default};

    &:hover {
      border-color: ${colors.action.inline.border.hover};
      background: ${colors.action.inline.background.hover};
      color: ${colors.action.inline.text.hover};
    }

    &:active {
      border-color: ${colors.action.inline.border.selected};
      background: ${colors.action.inline.background.selected};
      color: ${colors.action.inline.text.selected};
    }

    &:disabled {
      border-color: ${colors.action.inline.border.disabled};
      background: ${colors.action.inline.background.disabled};
      color: ${colors.action.inline.text.disabled};
    }
  `,
}
